import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { MaybeCognitoError } from '@move-frontend/auth';
import { useUserDataFromUrl } from './helpers/useUserDataFromUrl';
import { useResetPasswordErrorMessage } from './helpers/useResetPasswordErrorMessage';
import { ErrorBarFooter } from '../../../shared/components/error/ErrorBarFooter';
import { SIGN_IN_DIALOG_HASH } from '../../sign-in/ui/SignInDialog';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ResetPasswordForm } from './form/ResetPasswordForm';
import { useNavigate } from '../../../shared/router/useNavigate';
import { PassengersPageId } from '../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../app/pages/ui/utils/useUrlForPageId';
import ContentWrap from '../../../../ui/components/Layout/ContentWrap';
import Responsive from '../../../../ui/utils/Responsive';

export const ResetPassword = () => {
	const { t } = useTranslation();
	const userData = useUserDataFromUrl();
	const redirectUrl = useUrlForPageId(PassengersPageId.Parking);
	const [error, setError] = useState<MaybeCognitoError | undefined>(undefined);
	const navigate = useNavigate();

	useEffect(() => {
		if (!userData) {
			navigate(redirectUrl);
		}
	}, [userData, redirectUrl]);

	if (!userData) {
		return null;
	}

	const onSuccess = () => {
		const url = `${redirectUrl}${SIGN_IN_DIALOG_HASH}`;
		navigate(url);
	};

	return (
		<>
			<Wrap>
				<h3>{t('web_reset_password_form_title')}</h3>
				<ResetPasswordForm
					onSuccess={onSuccess}
					onFailure={setError}
					{...userData}
				/>
			</Wrap>
			{error && <ErrorMessage error={error} />}
		</>
	);
};

const Wrap = styled(ContentWrap)`
	margin-bottom: 80px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: 40px;
	}
`;

interface IErrorMessageProps {
	error: MaybeCognitoError;
}

const ErrorMessage = ({ error }: IErrorMessageProps) => {
	const message = useResetPasswordErrorMessage(error);

	return <ErrorBarFooter>{message}</ErrorBarFooter>;
};
